import React from 'react'

export default function AboutServices() {
  return (
    <>
      <div className="container about-services-con">
        <div className="row row-cols-4 about-services-row">
            <div className="col about-ser-1">
                <div className="marketing-section">
                    <h4>Marketing</h4>
                </div>
                <div className="management-section">
                    <h4>Management</h4>
                </div>
            </div>
            <div className="col about-ser-2">
                <div className="creativity-section">
                    <h4>Creativity</h4>
                </div>
                <div className="design-section">
                    <h4>Design</h4>
                </div>
            </div>
            <div className="col about-ser-3">
                <div className="Consultancy-Section">
                    <h4>Consultancy</h4>
                </div>
            </div>
            <div className="col about-ser-4">
                <div className="technical-delivery-section">
                    <h4>Technical Delivery</h4>
                </div>
                <div className="development-section">
                    <h4>Development</h4>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}
